import Arquivo from "./arquivo";

export default class Documento {
  constructor(id='', descricao='', instrucao='', modelo='', arqs=[], obrigatorio = false) {
    this.id = id;
    this.descricao = descricao;
    this.instrucao = instrucao;
    this.modelo = modelo;
    this.arquivos = arqs.map(arq => new Arquivo(arq.id, arq.nome));
    this.obrigatorio = obrigatorio;
  }
}
